import { render, staticRenderFns } from "./PortalDateTime.vue?vue&type=template&id=36513a55&scoped=true&"
import script from "./PortalDateTime.vue?vue&type=script&lang=ts&"
export * from "./PortalDateTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36513a55",
  null
  
)

export default component.exports